import { render, staticRenderFns } from "./WalletPanel.vue?vue&type=template&id=6f768ee4&scoped=true"
import script from "./WalletPanel.vue?vue&type=script&lang=js"
export * from "./WalletPanel.vue?vue&type=script&lang=js"
import style0 from "./WalletPanel.vue?vue&type=style&index=0&id=6f768ee4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f768ee4",
  null
  
)

export default component.exports